import { render } from "./EditAggregationModal2.vue?vue&type=template&id=6b889f7c&scoped=true"
import script from "./EditAggregationModal2.vue?vue&type=script&lang=js"
export * from "./EditAggregationModal2.vue?vue&type=script&lang=js"

import "./EditAggregationModal2.vue?vue&type=style&index=0&id=6b889f7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b889f7c"]])

export default __exports__